import axiosWrap from './axios'
import logError from './logger'

export const getInfo = () => {
  return axiosWrap({ url: '/info', method: 'GET' })
    .then(({ data }) => data)
    .catch('ERROR GETINFO AXIOS CALL', logError)
}
